export enum RewardlyTabs {
	MY_STARS = 'LABEL_TAB_MY_STARS',
	BALANCE = 'LABEL_TAB_EMPLOYEE_BALANCE',
	RECOGNITIONS = 'LABEL_TAB_RECOGNITIONS',
	CONFIGURE = 'LABEL_TAB_CONFIGURE',
}

export const REWARDLY_TAB_KEYS = [
	RewardlyTabs.MY_STARS,
	RewardlyTabs.BALANCE,
	RewardlyTabs.RECOGNITIONS,
	RewardlyTabs.CONFIGURE
];
